import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { PartIcon } from '@/icons/parts';
import { categoryLabel } from '@/data/categories';
import { fx, type CurrencyCode } from '@/lib/currency';
import { useCartStore } from '@/stores/cartStore';
import type { Part } from '@/types/Part';

interface PartCardProps {
  part: Part;
  currency: CurrencyCode;
}

export default function PartCard({ part, currency }: PartCardProps) {
  const addLine = useCartStore((s) => s.addLine);

  function handleAdd(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    addLine({
      partId: part.id,
      qty: 1,
      unitPrice: part.price,
      shippingWeight: part.weight,
      snapshot: {
        title: part.title,
        sku: part.sku,
        ...(part.casting !== undefined ? { casting: part.casting } : {}),
        iconId: part.iconId,
      },
    });
    toast.success('Added to quote', { description: part.title });
  }

  const firstPhoto = part.photos?.[0];

  return (
    <Link to={`/inventory/${part.id}`} className="part-card">
      <div className="part-photo">
        {firstPhoto ? (
          <img src={firstPhoto.url} alt={firstPhoto.alt} className="part-photo-img" />
        ) : (
          <PartIcon iconId={part.iconId} size={80} />
        )}
        <div className="badge">{part.type}</div>
        <div className="auth">✓ Authenticated</div>
        {part.status === 'reserved' && (
          <div className="part-photo-reserved badge reserved">Reserved</div>
        )}
      </div>
      <div className="part-info">
        <div className="part-cat">{categoryLabel(part.category)}</div>
        <div className="part-title">{part.title}</div>
        <div className="part-meta">
          <span>YR {part.year}</span>
          {part.casting && <span>{part.casting.split(' ')[0]}</span>}
          <span>{part.condition}</span>
        </div>
        <div className="part-footer">
          <div className="part-price">
            {fx(part.price, currency)}
            <small>{part.weight} lbs ship</small>
          </div>
          <button
            type="button"
            className="btn sm"
            onClick={handleAdd}
            disabled={part.status === 'reserved'}
            title={part.status === 'reserved' ? 'Reserved — not available' : 'Add to quote'}
          >
            ＋ Quote
          </button>
        </div>
      </div>
    </Link>
  );
}
